import Vue from 'vue/dist/vue.esm.js'
Vue.component 'report-involved-employee-row',
  template: JST['report_rows/involved_employee_row']()
  props: ['row']

  data: ->
    destroying: false

  computed:
    rowId: ->
      "row-#{@row.id}"

  methods:
    destroyInvolvedEmployeeRow: ->
      return if @destroying # don't run request twice if button is quickly pressed more than once
      if confirm I18n.t("javascript.row_delete_confirmation")
        @destroying = true
        authenticity_token = $('meta[name="csrf-token"]').attr('content')

        $.ajax
          dataType: 'JSON',
          url: "/admin/involved_employee_rows/#{@row.id}",
          data: {authenticity_token: authenticity_token},
          method: 'DELETE'
        @.$emit('destroy-row', @row)
